import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllSalesPartsView } from "src/components/views/erp/sales/masterData/salesParts/AllSalesPartsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salesParts")({
	staticData: { title: i18n.t("sales_parts"), legacyViewKey: "salesPartsOverViewPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllSalesPartsView />;
}
